import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Which ad placements are enabled (admin-controlled). Fetched once, cached.
const DEFAULTS = { in_list: true, side_rail: true, side_rail_left: true, slideshow: true, in_feed: true, detail_bottom: true };
let cache = null;
let promise = null;

export function loadAdSettings() {
    if (cache) return Promise.resolve(cache);
    if (!promise) {
        promise = api.get("/ad-settings")
            .then((r) => { cache = { ...DEFAULTS, ...(r.data || {}) }; return cache; })
            .catch(() => { cache = { ...DEFAULTS }; return cache; });
    }
    return promise;
}

export function setAdSettingsCache(values) {
    cache = { ...DEFAULTS, ...(values || {}) };
    window.dispatchEvent(new CustomEvent("ad-settings", { detail: cache }));
}

// Returns whether a given placement is enabled (defaults to true until loaded).
export function useAdSetting(key) {
    const { user } = useAuth();
    const isPro = !!(user && user.is_pro);
    const [on, setOn] = useState(cache ? cache[key] !== false : true);
    useEffect(() => {
        let alive = true;
        loadAdSettings().then((s) => { if (alive) setOn(s[key] !== false); });
        const h = (e) => setOn(e.detail[key] !== false);
        window.addEventListener("ad-settings", h);
        return () => { alive = false; window.removeEventListener("ad-settings", h); };
    }, [key]);
    // Pro members never see ads, regardless of the admin toggles.
    return on && !isPro;
}
